export default "__VITE_ASSET__B$srt5Af__"